import {
  numberToCurrencyString,
  numberToDisplayString,
} from 'further-ui/utils';
import {
  ConsiderationType,
  HoldingClassInvestmentsConsiderationValues,
} from '../../../types';
import { CurrencyCode } from 'further-types/lp/vehicle';

type ConsiderationCellProps = {
  investmentHoldingClass:
    | HoldingClassInvestmentsConsiderationValues
    | undefined;
  rowKey: string & ConsiderationType;
  currency: CurrencyCode;
};

const formatValue = (
  value: number | undefined,
  rowKey: ConsiderationType,
  currency: CurrencyCode,
) => {
  if (rowKey === ConsiderationType.UnitsRealised) {
    return value ? numberToDisplayString(value) : '-';
  }
  return numberToCurrencyString(value ?? 0, { currency, unlimitedDp: true });
};

const ConsiderationCell: React.FC<ConsiderationCellProps> = ({
  investmentHoldingClass,
  rowKey,
  currency,
}) => {
  if (!investmentHoldingClass) {
    return <span>-</span>;
  }

  const value = investmentHoldingClass[rowKey];

  return <span>{formatValue(value, rowKey, currency)}</span>;
};

export default ConsiderationCell;
